<template>
  <v-container fluid class="expense-page pa-4">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="createdLead"
    />

    <div class="expense-top-card">
      <div class="expense-header">
        <div class="expense-title-wrap">
          <v-btn icon small class="mr-2" to="/expense/home">
            <v-icon>mdi-home-outline</v-icon>
          </v-btn>

          <div>
            <div class="expense-title">Expense</div>
            <div class="expense-subtitle">
              Manage expenses, payees, and reports.
            </div>
          </div>
        </div>

        <div class="expense-actions">
          <v-btn
            v-if="checkRightStatus(4)"
            small
            rounded
            color="primary"
            dark
            @click="add"
          >
            <v-icon left small>mdi-plus</v-icon>
            New
          </v-btn>

          <v-btn small rounded outlined to="/expense/list">
            <v-icon left small>mdi-format-list-bulleted</v-icon>
            List
          </v-btn>

          <v-btn small rounded outlined to="/expense/payee/list">
            <v-icon left small>mdi-account-cash-outline</v-icon>
            Payee
          </v-btn>
        </div>
      </div>
    </div>

    <div class="expense-route-content">
      <router-view />
    </div>
  </v-container>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import expenseStore from "./store.js";
import { mapGetters } from "vuex";

const Create = () => import("../Expense/components/Create");

export default {
  name: "expense",

  mixins: [RegisterStoreModule],

  components: {
    Create,
  },

  data() {
    return {
      active: null,
      createDialog: false,
    };
  },

  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },

  created() {
    this.registerStoreModule("expense", expenseStore);
    document.title = "smplsale - Expense";
  },

  methods: {
    createdLead() {
      this.close();

      if (this.$route.path !== "/expense/list") {
        this.$router.push({ path: "/expense/list" });
      }
    },

    add() {
      this.createDialog = true;
    },

    close() {
      this.createDialog = false;
    },
  },
};
</script>

<style scoped>
.expense-page {
  background: #f8fafc;
  min-height: 100%;
}

.expense-top-card {
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
  margin-bottom: 16px;
}

.expense-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.expense-title-wrap {
  display: flex;
  align-items: center;
}

.expense-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.expense-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.expense-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.expense-route-content {
  padding: 0;
}

@media (max-width: 600px) {
  .expense-page {
    padding: 10px !important;
  }

  .expense-actions {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .expense-actions .v-btn {
    width: 100%;
  }
}
</style>